<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-row class="strategio-titles-windows" >
            <v-col cols="5" class="d-flex">
              <v-icon color="black" style="font-size:52px; margin-right: 5px;"
                @click="goBack"
                >arrow_back</v-icon>
              <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                Procesos 
              </span>
            </v-col>
          </v-row>

          <v-row class="ma-5 px-5">
            <autoservicio-list-processes
              :groupID="Number($route.params.groupID)"
            ></autoservicio-list-processes>
          </v-row>
        </v-container>
      </div>
    </v-main>

  </div>
</template>

<script>
import StrategioAppBar from '../../components/header-bar/strategio-app-bar.vue'
import AutoservicioListProcesses from '../../components/autoservicios/processes/autoservicio-list-processes.vue'

export default {
  name: 'autoservicios-group',
  components: {
    StrategioAppBar,
    AutoservicioListProcesses
  },
  data () {
    return {
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/routes/autoservicios/show-autoservicio-group.vue